import {createModel} from '@@/package/utils/ModelUtil';
import Model from '@@/package/mapper/Model';
import {LearningChapterModel} from "~~/package/mapper/learning/model/LearningChapterModel";

export class LearningCourseModel extends Model {
    constructor(
        public id: number = 0,
        public title: string = "",
        public trackId: number = 0,
        public trackTitle: string = "Temp",
        public trackLevelAuthFlag: boolean = false,
        public trackLevelId: number = 0,
        public recentTaskId: number = 0,
        public progress: number = 0,
        public onBoardingClickedFlag: boolean = false,
        public chapterList: LearningChapterModel[] = []
    ) {
        super();
    }

    public static create(model: Partial<LearningCourseModel>): LearningCourseModel {
        return createModel<LearningCourseModel>(LearningCourseModel, {
            ...model
        });
    }
}
